module.exports = __webpack_public_path__ + "img/03-2-15GF报告.78c1cd2e.svg";